<template> 
  <div class="availables__casas-box center-text">
    <div class="availables__casas-title">
      <div :class="changeColorCount" class="count">{{ availables.length }}</div>
      <div class="text">
        <h2>CASAS DISPONIBLES</h2>
      </div> 
    </div>
    <h2 class="center-text range__container-title">
        Filtrar Tipo de Casas
      </h2>
    <div class="u__center-flex">
      
      <div class="availables__casas-buttons">
        <div @click="showAllModels()" :class="fillAll" class="availables__casas-buttons-btn"></div>
        <div class="availables__casas-buttons-text">TODOS</div>
      </div>
    </div>
    <div class="u__display-inlineblock" v-for="(model, index) in setModels" :key="index">
      <div class="availables__casas-buttons">
        <div @click="activeModelClick(model),updateActiveModel()" :class="fillActive(model)" class="availables__casas-buttons-btn"></div>
        <div class="availables__casas-buttons-text">{{textOption}} {{ model.type }}</div>
      </div>
    </div>
    <div class="contents-rangers">
      <h2 class="center-text range__container-title">
        Filtrar Precios de Casas
      </h2>
      <div class="range__container-item range-price-container" >
        <div class="range-numbers range-numbers-left">
          {{ formatValue(returnMinPrice) }}
        </div>
        <div class="range-buttons range-buttons-price">
          <vue-slider
            class="rangeprice-custom range-price-custom"
            :tooltip-formatter="(val) => formatValue(val)"
            v-model="rangePrice"
            :min="returnMinPrice"
            :max="returnMaxPrice"
            @change="updateActiveModelRange()"
            :enable-cross="false"
          >
          </vue-slider>
        </div>
        <div class="range-numbers range-numbers-right">
          {{ formatValue(returnMaxPrice) }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters, mapActions} from "vuex"
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
export default {
  props: ["existFilter", "activeModel", "desarrollo","priceFilter"],
  components:{
  VueSlider 
  },
  data() {
    return {
      fillAll: "active__btn-casas",
      mutateModel : "",
      rangePrice: "",
      model:"",
      allM:true,
    }
  },
  computed: {
    ...mapGetters({
      filterModelos: "getStatusFilterModelos"
    }),
    setModels() {
      let personasMap = this.existFilter.map((item) => {
        return [item.type, item];
      });
      var personasMapArr = new Map(personasMap);
      return [...personasMapArr.values()];
    },
    availables() {
      return this.filterModelos.filter((i) => i.status == 2)
    },
    changeColorCount() {
      if(this.availables >= 0){
        return 'count__unavailable'
      }else{
        return 'count__available'
      }
    },
    textOption(){
      if(this.desarrollo === 'bosques_casas'){
        return 'MODELO'
      }else{
        return ''
      }
    },
    returnMinPrice() {
      if (this.priceFilter) {
        return Number(this.priceFilter[0]);
      } else {
        return false;
      }
    },
    returnMaxPrice() {
      if (this.priceFilter) {
        return Number(this.priceFilter[1]);
      } else {
        return false;
      }
    },

  },
  methods: {
    ...mapActions(["getFilterModelos"]),
    formatValue(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    activeModelClick(model){
      this.model = model
    },
    updateActiveModel() {
      this.allM=false
      let model = this.model
      let typeModel;
      let arrModel;
      typeModel = model.type
      if(this.desarrollo==='bosques_casas'){
        let unav = this.filterModelos.filter((i) => i.available ==0 )
        let avail = this.existFilter.filter(
          (i) => i.type == typeModel && i.available >0 && i.value >= this.rangePrice[0] && i.value <= this.rangePrice[1])
        arrModel = unav.concat(avail)

      }else{
        let unav = this.filterModelos.filter((i) => i.available ==0 && i.reserved==0 )
        let avail = this.existFilter.filter(
          (i) => i.type == typeModel && (i.available >0 || i.reserved>0) && i.value >= this.rangePrice[0] && i.value <= this.rangePrice[1])
        arrModel = unav.concat(avail)
       
      }
      this.$emit('onUpdateModel', arrModel)

      this.mutateModel = model.type;
      this.fillAll = '';
    },
    updateActiveModelRange() {
      let model = this.model
      let typeModel;
      let arrModel;
      typeModel = model.type
      if(this.allM){
        if(this.desarrollo==='bosques_casas'){
        let unav2 = this.filterModelos.filter((i) => i.available ==0 )
        let avail2 = this.existFilter.filter(
          (i) => i.available >0 && i.value >= this.rangePrice[0] && i.value <= this.rangePrice[1])
        arrModel = unav2.concat(avail2)
        }else{
          let unav2 = this.filterModelos.filter((i) => i.available ==0 && i.reserved==0 )
        let avail2 = this.existFilter.filter(
          (i) => (i.available >0 || i.reserved>0) && i.value >= this.rangePrice[0] && i.value <= this.rangePrice[1])
        arrModel = unav2.concat(avail2)
        }
         this.$emit('onUpdateModel', arrModel)
      }else{
        if(this.desarrollo==='bosques_casas'){
        let unav = this.filterModelos.filter((i) => i.available ==0 )
        let avail = this.existFilter.filter(
          (i) => i.type == typeModel && i.available >0 && i.value >= this.rangePrice[0] && i.value <= this.rangePrice[1])
        arrModel = unav.concat(avail)
        
      }else{
        let unav2 = this.filterModelos.filter((i) => i.available ==0 && i.reserved==0 )
        let avail2 = this.existFilter.filter(
          (i) =>i.type == typeModel && (i.available >0 || i.reserved>0) && i.value >= this.rangePrice[0] && i.value <= this.rangePrice[1])
        arrModel = unav2.concat(avail2)
        
       
        }
        this.$emit('onUpdateModel', arrModel)

        this.mutateModel = model.type;
        this.fillAll = '';
      }
    },
    showAllModels() {
      this.getFilterModelos(this.existFilter)
      this.fillAll = 'active__btn-casas'
      this.mutateModel = ''
      this.allM=true
      this.rangePrice = [this.returnMinPrice, this.returnMaxPrice];

    },
    fillActive(model) {
      if (this.mutateModel === model.type) {
        return 'active__btn-casas'
      }else {
        return 'desactive__btn-casas'
      }
    },

     

  },
  mounted(){
    this.rangePrice = [this.returnMinPrice, this.returnMaxPrice];

  },
  created() {
  },
  updated() {
  }
}
</script>
<style scoped>
.range__container-item {
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  padding-top: 2rem;
}
.range-numbers {
  font-size: 1.4rem;
  /* min-width: 40px; */
  
  /* width: 25%; */
  font-weight: 700;
}

.range-buttons {
  width: 100%;
  max-width: 300px;
}
.rangeprice-custom .vue-slider-dot-handle {
  background: #152541;
}
.rangeprice-custom .vue-slider-process {
  background: #152541;
}
.rangeprice-custom .vue-slider-dot-tooltip-inner {
  background: #152541;
  border-color: #152541;
}
.range-numbers-left {
  text-align: right;
  padding-right:15px;
}
.range-numbers-right {
  text-align: left;
  padding-left:15px;
}
.range__container-title {
    padding-top: 2.5rem;
  }
@media (min-width: 1201px) {
  .range__container-title {
    font-size: 1.8rem;
  }
  
}
@media (max-width: 1200px) {
  .range__container-title {
    font-size: 2.3rem;
  }
}
.availables__casas-box{
    padding-bottom: 3rem;
  }

@media (max-width: 767.67px) {
  .range__container-title {
    font-size: 2rem;
  }
  
}


</style>